export const isObjectId = (id: string) => !!id?.match(/^[0-9a-fA-F]{24}$/)
